import React from "react";

function TableShimmer({ rows = 10, cols = 7 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i}>
          {Array.from({ length: cols }).map((_, j) => (
            <td key={j}>
              <div className="shimmer-box" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export default TableShimmer;
